/**
 * Returns a string that can be inserted into a regular expression to match the
 * given string
 *
 * @example
 * function startsWith(prefix: string, str: string) {
 *   return new RegExp(`^${escapeRegExp(prefix)}`).test(str)
 * }
 * startsWith('...', '...should match...') === true
 * startsWith('...', 'should not match') === false
 * startsWith('**TODO**', '**TODO** update comments') === true
 * startsWith('**TODO**', '*TODO* update comments') === false
 */
export function escapeRegExp(str: string): string {
  return str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
}
